export default {
	options: {
		customProperties: true,
	},
	themes: {
		//theme colors
		light: {
			primary: "#35bcbc",
			secondary: "#eff6f8",
			third: "#b5b8b8",
			lightGrey: "#ccc",
			accent: {
				base: "#35bcbc",
				lighten1: "#eff6f8",
				lighten2: "#eff6f8",
			},
			violet: "#7864ca",
			// background: "#f6f7fb",
			background: {
				base: "#f9f9f9", // backround of main
				lighten1: "#fff", // background of wall card
			},
			lightContrast: "#fff",
			darkContrast: "#000",
			grey: {
				base: "#838391",
				darken1: "#3a394c",
				darken2: "#50505e",
				darken3: "#3a394c",
				lighten1: "#f9f9f9",
				lighten2: "#f2f2f3",
				lighten3: "#d9d9dd",
				lighten4: "#eaeaeb",
				lighten5: "#bebec5",
			},
			red: {
				base: "#de1c22",
				darken1: "#eac2c3",
				darken2: "#a53438",
				darken3: "#de1c22",
				lighten1: "#ffe0e1",
				lighten2: "#fae5e5",
				lighten3: "#de1c22",
				lighten4: "#de1c22",
				lighten5: "#de1c22",
			},
			success: {
				base: "#1ba769",
				lighten1: "#b5ecd4",
				lighten2: "#1ba769",
				lighten3: "#def2e9",
			},
			warning: "#e86825",
			gold: "#EDC537",
			blue: "#126EFF",
		},
		dark: {
			primary: "#e5a44d",
			accent: {
				base: "#f5b45f",
				lighten1: "#f9e6ce",
				lighten2: "#fdf6ef",
			},
			// accent: {
			// 	base: "#2196f3",
			// 	lighten1: "#95e8ff",
			// 	lighten2: "#b5ffff",
			// },
			grey: {
				lighten1: "#c1c1c1",
				lighten2: "#c1c1c1",
				lighten3: "#595959",
				lighten4: "#171717",
			},
			background: {
				base: "#171717", // backround of main
				lighten1: "#1e1e1e", // background of wall card
			},
		},
	},
}
